import { EditableInput } from 'Components'

EditableAttributeInput = ({ valueKey, type, node, ...rest }) ->

  <EditableInput
    type={type}
    {...rest}
  />

export default EditableAttributeInput
